import { render } from "./AiCategorySectionTitle.vue?vue&type=template&id=48261363&scoped=true"
import script from "./AiCategorySectionTitle.vue?vue&type=script&lang=js"
export * from "./AiCategorySectionTitle.vue?vue&type=script&lang=js"

import "./AiCategorySectionTitle.vue?vue&type=style&index=0&id=48261363&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-48261363"]])

export default __exports__